/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Open_LocationInputs */

const cs_documents_open_location = /** @type {(inputs: Documents_Open_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít umístění`)
};

const en_documents_open_location = /** @type {(inputs: Documents_Open_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open location`)
};

/**
* | output |
* | --- |
* | "Open location" |
*
* @param {Documents_Open_LocationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_open_location = /** @type {((inputs?: Documents_Open_LocationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Open_LocationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_open_location(inputs)
	return cs_documents_open_location(inputs)
});